import LoanRequestComponent from 'components/LoanRequest';
import PermissionGuard from 'components/Global/PermissionGuard';

export const LoanRequest = () => {
	return (
		<PermissionGuard permission="Allow_Loan_Request">
			<LoanRequestComponent />
		</PermissionGuard>
	);
};
